/*
* M: Mobile devices
* L: Larger devices (Laptop/Tablet)
*
* FS: Font size
* */

export const arw = {
  Primary: '#261D1D',
  Secondary: '#D80011',
};